import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Tag, IconTick } from "braid-design-system";
import { useSkillsMatchSignedInContext } from "../../../JDVLayout/JDVLayout.mjs";
import { overflow } from "../SkillsMatchSignedIn.css.mjs";
const UnselectableQualities = ({
  qualities
}) => {
  const { limit, isExpanded } = useSkillsMatchSignedInContext();
  const displayedQualities = qualities.slice(0, limit);
  const hiddenQualities = qualities.slice(limit, qualities.length);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    displayedQualities.map((item) => /* @__PURE__ */ jsx(Box, { className: overflow, children: /* @__PURE__ */ jsx(Tag, { size: "small", icon: /* @__PURE__ */ jsx(IconTick, {}), children: item.keyword.text }) }, `${item.keyword.ontologyId}`)),
    isExpanded && hiddenQualities.map((item) => /* @__PURE__ */ jsx(Box, { className: overflow, children: /* @__PURE__ */ jsx(Tag, { size: "small", icon: /* @__PURE__ */ jsx(IconTick, {}), children: item.keyword.text }) }, `${item.keyword.ontologyId}`))
  ] });
};
export {
  UnselectableQualities
};
